import { useLayoutEffect, useRef } from "react";
import { LayoutType, Wrapper, Layout } from '@rebootui';
import { Outlet, useLocation } from "react-router-dom";
import { MenuContextProvider } from "../../store/MenuContext";
import { SidebarContextProvider, useSidebar } from "../../store/SidebarContext";
import Sidebar from "../../components/controls/Sidebar";
import Header from "../../components/controls/Header";

const DocLayoutShell = () => {
    const contentRef = useRef<HTMLElement>(null);
    const location = useLocation();
    const { sidebarOpen } = useSidebar();

    useLayoutEffect(() => {
        const el = contentRef.current;
        if (el) {
            el.scrollTop = 0;
        }
        window.scrollTo(0, 0);
    }, [location.pathname, location.search]);

    const shellClass =
        sidebarOpen ? "doc-layout" : "doc-layout doc-layout--sidebar-collapsed";

    return (
        <div className={shellClass}>
            <Layout type={LayoutType.Sidebar}> 
                <Layout.Header>
                    <Header />
                </Layout.Header>
                <Layout.Sidebar>
                    <MenuContextProvider>
                        <Sidebar />
                    </MenuContextProvider>
                </Layout.Sidebar>
                <Layout.Content ref={contentRef}>
                    <Wrapper className="p-4 p-md-6 mx-3 mx-md-0">
                        <Outlet />
                    </Wrapper>
                </Layout.Content>
                {/*  <Layout.Footer>
                <Wrapper className="p-3">
                    <p className="mb-0 small opacity-75">© {new Date().getFullYear()} React Bootstrap. All rights reserved.</p>
                </Wrapper>
            </Layout.Footer>*/}
            </Layout>
        </div>
    );
};

const DocLayout = () => (
    <SidebarContextProvider>
        <DocLayoutShell />
    </SidebarContextProvider>
);

export default DocLayout;
